<template>
    <div id="the-scroller" :style="{height: scrollHeight + 'px'}"></div>
</template>

<script>
import { mapState } from 'vuex'
import { validScenes, sceneMap, sceneData } from '@/util/sceneMap'
import updateOnScroll from 'uos'
import { calc, styler, tween, spring } from 'popmotion'

export default {
    data() {
        return {
            progress: 0
        }
    },

    computed: {
        ...mapState(['h', 'clickedScene']),

        scrollHeight() {
            return this.h * validScenes.length * 2
        },

        scrollMax() {
            return this.scrollHeight - this.h
        },

        scrollScene() {
            for (let scene in sceneData) {
                let [min, max] = sceneData[scene].scrollProgress
                if (this.progress >= min && this.progress < max) {
                    return scene
                }
            }
            if (this.progress === 1) return 'overview'
        }
    },

    watch: {
        clickedScene(scene, oldscene) {
            // only do this if the last scene was null
            if (oldscene) return

            let fromProgress = this.progress
            let fromValue = calc.getValueFromProgress(
                0,
                this.scrollMax,
                fromProgress
            )

            let [start, end] = sceneData[scene].scrollProgress
            let toProgress = start + (end - start) / 2

            let toValue = calc.getValueFromProgress(
                0,
                this.scrollMax,
                toProgress
            )

            // todo - set a speed
            spring({ from: fromProgress, to: toProgress, damping: 20 }).start({
                update: p => {
                    let v = calc.getValueFromProgress(0, this.scrollMax, p)
                    this.viewportStyler.set('scrollTop', v)
                },
                complete: () => this.$store.commit('clickScene', null)
            })
        },

        scrollScene(scene, oldscene) {
            this.$store.commit('setScene', scene)
        }
    },

    mounted() {
        this.viewportStyler = styler(window)

        updateOnScroll(0, 1, progress => {
            this.progress = progress
        })
    }
}
</script>

<style>
</style>
